import { Dayjs } from 'dayjs'
import { ReactNode } from 'react'
import { Datatable } from './Datatable'
import { TableLink } from './TableLink'

export type TSelector<TItem> = (
  _item: TItem,
  _utils: {
    dayjs: (_date?: string | number | Date) => Dayjs
  },
) => ReactNode

export type TDatatable<TItem> = {
  id: string
  label: React.ReactNode
  colSize: number
  isSortable?: boolean
  sortKey?: string
  mobileHidden?: boolean
  mobileGrow?: boolean
  selector: TSelector<TItem>
}

export default Datatable
export { TableLink }
